module.exports = __webpack_public_path__ + "static/media/ziplock11.db16a082.png";